import script from "./CatalogPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogPage.vue?vue&type=script&setup=true&lang=js"

import "./CatalogPage.vue?vue&type=style&index=0&id=6502d128&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6502d128"]])

export default __exports__